import Webgl from '../Webgl';
import * as Uniform from '../Uniform';
import FxaaShader from '../../Webgl/Shader/FxaaShader';
import CanvasWrapper from '../../Webgl/CanvasWrapper';

export default (instance:string) => {
	let postgl = Webgl.getInstance(instance);
	
	let fbo = postgl.fbos[postgl.getPreviousFbo(instance)];

	let width = fbo.width;
	let height = fbo.height;

	if(!postgl.programs["fxaa"]){
		postgl.createProgram("fxaa", new FxaaShader());
	}

	postgl.useProgram("fxaa");
	(postgl.currentProgram.shader as FxaaShader).u_size = new Uniform.Uniform2f(width, height);
	postgl.render();
}